import { useEffect, useState } from "react";
import axios from "axios";

const url = 'https://computer-quiz-backend.herokuapp.com/quizzes/';

export const useGetQuiz = (id) => {
  const [quiz, setQuiz] = useState();
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchQuiz = async () => {
      try {
        const { data } = await axios.get(url + id, {
          headers: { 'api-token': localStorage.getItem('token') }
        });
        setQuiz(data);
      } catch (error) {
        setError(error.message);
      }
    };

    fetchQuiz();
  }, [id]);

  return { quiz, error };
};